<template>
  <NxInput
    name="enderecoComplemento"
    type="text"
    label="Complemento:"
    placeholder="EX: Norte"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputEnderecoComplemento',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputEnderecoComplemento.vue